/**
 * <s-sticky-atc> shows a compact add-to-cart bar while the product page's main
 * add-to-cart button is out of view. The bar is inert while hidden so it never
 * takes keyboard focus off-screen.
 */
class SStickyAtc extends HTMLElement {
  /** @type {IntersectionObserver | null} */
  #observer = null;

  connectedCallback() {
    const root = this.closest('[data-product-root]') ?? this.parentElement;
    const target = root?.querySelector('[data-main-atc]');
    if (!target || !('IntersectionObserver' in window)) {
      this.#setVisible(false);
      return;
    }

    this.#observer = new IntersectionObserver(([entry]) => {
      this.#setVisible(!entry.isIntersecting);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  /** @param {boolean} visible */
  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-atc')) {
  customElements.define('s-sticky-atc', SStickyAtc);
}
